import { render } from "./TopicCommentaryPage.vue?vue&type=template&id=c2f1a7a4&scoped=true&ts=true"
import script from "./TopicCommentaryPage.vue?vue&type=script&lang=ts"
export * from "./TopicCommentaryPage.vue?vue&type=script&lang=ts"

import "./TopicCommentaryPage.vue?vue&type=style&index=0&id=c2f1a7a4&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f1a7a4"]])

export default __exports__